"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBBanner = require("./HBBanner.styles");
/** @deprecated use the specialized banner components instead. see them on our [Storybook](https://honeybook.github.io/hbui/?path=/story/hbbanner--info-banners) */
var HBBanner = function HBBanner(_ref) {
  var children = _ref.children,
    sticky = _ref.sticky,
    top = _ref.top,
    contentPadding = _ref.contentPadding,
    margin = _ref.margin,
    customTheme = _ref.customTheme,
    className = _ref.className,
    testId = _ref.testId,
    zIndex = _ref.zIndex;
  var textAlignment;
  if (customTheme !== null && customTheme !== void 0 && customTheme.textAlignment) {
    textAlignment = customTheme.textAlignment.replace('left', 'flex-start').replace('right', 'flex-end');
  }
  return /*#__PURE__*/_react["default"].createElement(_HBBanner.BannerContainerStyle, {
    top: top,
    sticky: sticky,
    margin: margin,
    minHeight: customTheme === null || customTheme === void 0 ? void 0 : customTheme.minHeight,
    boxShadow: customTheme === null || customTheme === void 0 ? void 0 : customTheme.boxShadow,
    className: className,
    background: customTheme === null || customTheme === void 0 ? void 0 : customTheme.backgroundColor,
    "data-testid": testId,
    zIndex: zIndex
  }, /*#__PURE__*/_react["default"].createElement(_HBBanner.BannerBar, {
    color: customTheme === null || customTheme === void 0 ? void 0 : customTheme.barColor
  }), /*#__PURE__*/_react["default"].createElement(_HBBanner.BannerContent, {
    fontSize: customTheme === null || customTheme === void 0 ? void 0 : customTheme.fontSize,
    textAlignment: textAlignment,
    contentPadding: contentPadding
  }, children));
};
var _default = exports["default"] = HBBanner;
//# sourceMappingURL=HBBanner.js.map